var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zm0 1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM7.5 3.5A.5.5 0 0 1 8 4v4h3a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5z","fill-rule":"evenodd"}})])};var toString = function () {return "/home/jenkins/workspace/b_kiwitaxi-cabinet-client_master@2/src/assets/icons/clock.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/clock.svg
// module id = lEdm
// module chunks = 9